var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({staticClass:"form-input",class:( _obj = {}, _obj[("input-" + _vm.size)] = true, _obj ),attrs:{"aria-autocomplete":_vm.autocomplete_id,"autocomplete":_vm.autocomplete_id,"autocapitalize":_vm.autocapitalize}},'input',_vm.input_props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }